import { Expose, Type } from "class-transformer";
import ShopRes from "../shop/ShopRes";

export default class RoomRes {
  @Expose() readonly roomId!: number;
  @Expose() readonly companyId!: number;
  @Expose() readonly shopId!: number;
  @Type(() => ShopRes)
  @Expose()
  readonly shop!: ShopRes;
  @Expose() readonly name!: string;
  @Expose() readonly note!: string | null;
  @Expose() readonly sort!: number | null;
  @Type(() => Boolean)
  @Expose()
  readonly isActive!: boolean;
  @Type(() => Date)
  @Expose()
  readonly createdAt!: Date;
  @Type(() => Date)
  @Expose()
  readonly updatedAt!: Date;
}
